import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'statusClassGed',
    standalone: false
})
export class StatusClassGedPipe implements PipeTransform {

    transform(value: string): string {
        switch (value) {
            case 'VAL':
                return '-is-validated';
            case 'APP':
                return '-is-waiting';
            case 'REF':
                return '-is-refused';
            case 'RED':
                return '-is-closed';
        }

        return '';
    }

}
